import BaseAPI from "../api";

const path: string = "/edpex-form";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class edpexFormMasterAPI extends BaseAPI {
  static getEdpexFormMasterByType(query: any): Promise<any> {
    return this.api.get(`${path}/get-one`, {
      params: { ...query },
    });
  }

  static getDownloadFileEdpexFormMaster(id_file: number): Promise<any> {
    return this.api.get(`${path}/${id_file}/download`, {
      responseType: "arraybuffer",
    });
  }

  static updateEdpexFormMaster(body: any): Promise<any> {
    return this.api.patch(`${path}`, body);
  }

  static uploadFileEdpexFormMaster(type: string, body: FormData): Promise<any> {
    return this.api.post(`${path}/upload-file?edpex_form_file_type=${type}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}
